export { default as translations } from './translations.json';
export const SIGNUP_STEPS = ['email_entered', 'name_entered', 'password_entered', 'profile_started'];
export const DELAY_HOURS = parseInt(
  typeof process !== 'undefined' ? (process.env?.ABANDONED_SIGNUP_DELAY_HOURS || '1') : '1', 10
);
